import * as types from './../constants';
import { setGamesThunk } from './gamesAction';

export const fillStore = value => ({ type: types.FILL_STORE, payload: value });

export const fillStoreThunk = value => async dispatch => {
    await dispatch(setGamesThunk())
    await dispatch(fillStore(value))
}